// SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
// Copyright (C) 2023-2024 (original work) Open Assessment Technologies SA
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License

import config from '@/config';
import { getPermissionsGuard } from '@/core/guards/permissionsGuard';

export const routing = [
    {
        path: [config.routes.batteries.home],
        guard: getPermissionsGuard([{ resource: 'portal.battery', scopes: ['view'] }]),
        controller: () => import('./controllers/batteries')
    },
    {
        path: [config.routes.batteries.create],
        guard: getPermissionsGuard([{ resource: 'portal.battery', scopes: ['create'] }]),
        controller: () => import('./controllers/create.edit')
    },
    {
        path: [config.routes.batteries.edit],
        guard: getPermissionsGuard([{ resource: 'portal.battery', scopes: ['edit'] }]),
        controller: () => import('./controllers/create.edit')
    },
    {
        path: [config.routes.batteries.selectDeliveries],
        guard: getPermissionsGuard([{ resource: 'portal.battery', scopes: ['edit'] }]),
        controller: () => import('./controllers/addDeliveries')
    },
    {
        path: [config.routes.batteries.selectDeliveriesForExisting],
        guard: getPermissionsGuard([{ resource: 'portal.battery', scopes: ['edit'] }]),
        controller: () => import('./controllers/addDeliveries')
    }
];
